var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcoDeleteHistory = function SvgIcoDeleteHistory(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M11.25 21H7q-.824 0-1.412-.587A1.93 1.93 0 0 1 5 19V6H4V4h5V3h6v1h5v2h-1v4.3a8 8 0 0 0-.988-.213A7 7 0 0 0 17 10V6H7v13h3.3q.15.525.4 1.038.25.512.55.962M9 17h1q0-1.575.5-2.588L11 13.4V8H9zm4-5.75q.424-.275.963-.55A5 5 0 0 1 15 10.3V8h-2zM17 22q-2.075 0-3.537-1.462Q12 19.074 12 17q0-2.075 1.463-3.537Q14.926 12 17 12q2.075 0 3.538 1.463T22 17t-1.462 3.538Q19.074 22 17 22m1.65-2.65.7-.7-1.85-1.85V14h-1v3.2z"
  })));
};
export default SvgIcoDeleteHistory;